"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcaution = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcaution` : '') + (description ? ` desc-brandedcaution` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcaution"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcaution"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.62 60.01a5.61 5.61 0 0 1-5.03-8.1L26.97 7.1a5.64 5.64 0 0 1 10.06 0l24.38 44.8a5.6 5.6 0 0 1-5.03 8.1H7.63Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M61.37 51.9 37 7.09A5.62 5.62 0 0 0 31.97 4v56h24.37a5.6 5.6 0 0 0 5.03-8.1Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.57 22.26c-.1-1.14.57-2.04 1.68-2.04h3.44c1.1 0 1.83.9 1.73 2.04l-.3 15.85c-.1 1.04-2.19 1.7-3.14 1.7-.96 0-2.92-.65-3.02-1.7l-.39-15.85Zm3.4 21c1.96 0 3.4 1.43 3.4 3.28V47c0 1.85-1.43 3.27-3.4 3.27-1.96 0-3.4-1.42-3.4-3.27v-.47a3.29 3.29 0 0 1 3.4-3.27Z",
    fill: "#FFF5EB"
  }));
};
var _default = exports.default = brandedcaution;